<div id="company-tree-styles">
    <button mat-icon-button [matMenuTriggerFor]="appMenu" (menuOpened)="triggerTreeInit()"
        (menuClosed)="resetCompanyTree()" class="company-tree-view-header">

        <div class="company-category">
            <span>{{selectedCompany}}</span>
        </div>
        <div>
            <mat-icon>arrow_drop_down</mat-icon>
        </div>
    </button>
</div>
<mat-menu #appMenu="matMenu" class="company-tree-container">
    <div (click)="$event.stopPropagation();">
        <input placeholder="Buscar" #textbox (keyup)="searchCompany(textbox.value)" [(ngModel)]="searchString">
        <div  id="company-tree" #companyTree></div>
    </div>
</mat-menu>